import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Oauth, OauthLoginResult, AccountOauthSWParam } from '../oauth.model';
import { OauthActions, OauthActionTypes } from '../actions/oauth.actions';


export interface OauthLoginState {
  Loaded: boolean;
  Loading: boolean;
  entities: OauthLoginResult;
}

export const initialOauthLoginState: OauthLoginState = {
  Loaded: false,
  Loading: false,
  entities: { Flag: false, Message: -1 }
};

export interface AccountOauthSWParamState {
  Loaded: boolean;
  entities: AccountOauthSWParam;
}

export const initialAccountOauthSWParamState: AccountOauthSWParamState = {
  Loaded: false,
  entities: { UId: '', Platform: 0, PId: '', SW: '', ExpiredTimeStamp: 0, Email: '' }
};

export interface State extends EntityState<Oauth> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Oauth> = createEntityAdapter<Oauth>({
  selectId: info => info.Id
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function OauthLoginreducer(
  state = initialOauthLoginState,
  action: OauthActions
): OauthLoginState {
  switch (action.type) {
    case OauthActionTypes.GetOauthLogin: {
      return {...state, Loaded: false, Loading: true};
    }

    case OauthActionTypes.OauthLogin: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case OauthActionTypes.OauthLoginFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export function AccountOauthSWParamreducer(
  state = initialAccountOauthSWParamState,
  action: OauthActions
): AccountOauthSWParamState {
  switch (action.type) {
    case OauthActionTypes.GetAccountOauthSWParam: {
      return {...state, Loaded: true, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export function reducer(
  state = initialState,
  action: OauthActions
): State {
  switch (action.type) {
    case OauthActionTypes.GetOauths: {
      return {...state, Loaded: false, Loading: true};
    }

    case OauthActionTypes.LoadOauths: {
      return adapter.setAll(action.payload, {...state, Loaded: true, Loading: false});
    }

    case OauthActionTypes.LoadOauthsFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case OauthActionTypes.AddAccountByOauth: {
      return {...state, Loaded: false, Loading: true};
    }

    case OauthActionTypes.AddAccountOauth: {
      return {...state, Loaded: false, Loading: true};
    }

    case OauthActionTypes.DeleteAccountOauth: {
      return {...state, Loaded: false, Loading: true};
    }

    case OauthActionTypes.UpdateAccountEmail: {
      return {...state, Loaded: false, Loading: true};
    }

    // case OauthActionTypes.UpsertAccountOauthSuccess: {
    //   return adapter.upsertOne(action.payload.Oauth, {...state, Loaded: true, Loading: false});
    // }

    case OauthActionTypes.DeleteAccountOauthSuccess: {
      return adapter.removeOne(action.payload.id, {...state, Loaded: true, Loading: false});
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
